<template>
  <!-- MBR068 confirm payment — no mockup, follows member_app_UI/song_fa_members_bookings_mobile -->
  <div class="page-header align-items-start min-vh-100 mbr-bk">
    <span class="mask bg-white"></span>
    <div class="container p-0" v-if="isLoadDone">
      <header class="mbr-bk__bar">
          <button type="button" class="mbr-bk__back" :aria-label="$t('common.back')" @click="backTermsConditions()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m15 18-6-6 6-6" />
            </svg>
          </button>
        <h1 class="mbr-bk__title">{{ $t('booking.confirm_booking') }}</h1>
      </header>
      <main class="mbr-bk__body">
          <section class="mbr-bk__card">
            <div class="mbr-bk__row">
              <span class="mbr-bk__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
              </span>
              <div class="mbr-bk__row-text">
                <p class="mbr-bk__eyebrow">{{ $t('booking.booking') }}</p>
                <p class="mbr-bk__strong">{{ formatDate(timeSlotSelect.date) }}</p>
                <p class="mbr-bk__muted">{{ memberBooking.time_text }}</p>
              </div>
            </div>
            <div class="mbr-bk__row">
              <img :src="memberBooking.venue_image" class="mbr-bk__thumb" :alt="memberBooking.venue_name" />
              <div class="mbr-bk__row-text">
                <p class="mbr-bk__eyebrow">{{ $t('booking.venue') }}</p>
                <p class="mbr-bk__strong">{{ memberBooking.venue_name }}</p>
              </div>
            </div>
            <div class="mbr-bk__price" v-if="memberBooking.price > 0">
              <div class="mbr-bk__price-line">
                <span>{{ $t('booking.gst', { rate: memberBooking.gst_rate }) }}</span>
                <span>{{ memberBooking.gst_format }}</span>
              </div>
              <div class="mbr-bk__price-line mbr-bk__price-line--total">
                <span>{{ $t('booking.total') }}</span>
                <strong>{{ memberBooking.total_price_format }}</strong>
              </div>
            </div>
          </section>
      </main>
      <div class="mbr-bk__ctabar">
        <div class="mbr-bk__ctabar-inner">
          <button type="button" class="mbr-bk__cta" @click="processBooking()">
            <span>{{ $t('booking.proceed_to_payment') }}</span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14m-6-6 6 6-6 6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import BookingService from "../services/booking.service";
import moment from "moment";
import { getMerchantCode } from "@/config/utils";
import { isEnglish, formatDate as formatLocaleDate } from "@/i18n";
import { errorMessage } from "@/utils/errorMessage";

export default {
  name: "Booking completed",
  components: {
    MaterialSnackbar,
    MaterialLoading,
  },

  data() {
    return {
      isLoadDone: false,
      merchantCode: "",
      loaderActive: false,
      snackbar: "",
      message: "",
      memberBooking: {},
      venueId: this.$route.params.id ?? 0,
      branchId: this.$route.query.branch_id ?? 0,
    };
  },
  props: {
    typeSelect: {
      type: Object,
      required: true,
    },
    timeSlotSelect: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.timeSlotDetail();
  },
  mounted() {
    const code = getMerchantCode();
    this.merchantCode = code ? `/${code}` : "";
  },
  computed: {
    styleObject() {
      return {
        "--button-color": this.$store.state.buttonColor,
        "--label-color": this.$store.state.labelColor,
      };
    },
  },
  methods: {
    backTermsConditions() {
      this.$emit("back-terms-conditions");
    },

    formatDate(date) {
      if (!isEnglish()) {
        return formatLocaleDate(moment(date).toDate(), { weekday: "long", day: "numeric", month: "long", year: "numeric" });
      }
      return moment(date).format("dddd, D MMMM YYYY");
    },

    timeSlotDetail() {
      this.isLoadDone = false;
      this.showLoader();

      var dataForm = {
        slot_id: this.timeSlotSelect.id,
        venue_id: this.venueId,
        venue_type: this.typeSelect.id,
        branch_id: this.branchId,
      };

      BookingService.timeSlotDetail(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.memberBooking = response.data.data;
            this.isLoadDone = true;
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = errorMessage(error);
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    processBooking() {
      this.showLoader();
      const merchantCode = getMerchantCode();
      var url =
        location.protocol +
        "//" +
        location.host +
        "/" +
        merchantCode +
        "/booking-completed/booking_code";
      var dataSend = {
        success_url: url + "?session_id={CHECKOUT_SESSION_ID}",
        cancel_url: url,
        images: "",
        name: "Booking venue",
        unit_amount: this.memberBooking.total_price,
        quantity: 1,
        venue_id: this.venueId,
        venue_type_id: this.typeSelect.id,
        slot_id: this.timeSlotSelect.id,
        date_select: this.timeSlotSelect.date,
        branch_id: this.branchId,
      };

      BookingService.checkoutSessionStripe(dataSend, merchantCode).then(
        (response) => {
          if (response.data.result.isSuccess) {
            window.location.href = response.data.data.url;
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = errorMessage(error);
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>
<style scoped>
/* MBR068 BookingConfirmPayment */
.mbr-bk.page-header {
  overflow: visible;
  overflow-x: clip;
  font-family: var(--mbr-font-body);
  color: var(--mbr-color-ink-headline);
}

/* custom.css still carries the legacy `* { font-family: Poppins }` */
.mbr-bk :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-bk .mask {
  background: var(--mbr-color-canvas) !important;
  opacity: 1;
}

.mbr-bk .container {
  max-width: 440px;
  margin: 0 auto;
}

.mbr-bk__bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 20px 12px;
  background: rgba(var(--mbr-color-canvas-rgb), 0.95);
  border-bottom: 1px solid rgba(var(--mbr-color-outline-rgb), 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mbr-bk__back {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
  color: var(--mbr-color-primary);
  transition: transform 0.15s ease;
}

.mbr-bk__back:active {
  transform: scale(0.95);
}

.mbr-bk__back svg {
  width: 16px;
  height: 16px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-bk__title {
  margin: 0;
  font-family: var(--mbr-font-headline) !important;
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  letter-spacing: -0.02em;
  color: var(--mbr-color-ink-strong);
}

.mbr-bk__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* room for the fixed CTA bar */
  padding: 16px 20px 128px;
}

.mbr-bk__eyebrow {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mbr-color-ink-secondary);
}

.mbr-bk__strong {
  margin: 0;
  font-family: var(--mbr-font-headline) !important;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: var(--mbr-color-ink-strong);
  overflow-wrap: anywhere;
}

.mbr-bk__muted {
  margin: 2px 0 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
}

.mbr-bk__card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: var(--mbr-color-surface);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.6);
  border-radius: 24px;
  box-shadow: 0 1px 2px rgba(var(--mbr-color-primary-rgb), 0.05);
}

.mbr-bk__row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mbr-bk__row-text {
  min-width: 0;
}

.mbr-bk__icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--mbr-color-peach);
  border-radius: 14px;
  color: var(--mbr-color-primary);
}

.mbr-bk__icon svg {
  width: 22px;
  height: 22px;
}

.mbr-bk__thumb {
  flex: none;
  width: 48px;
  height: 48px;
  object-fit: cover;
  background: var(--mbr-color-tint);
  border-radius: 14px;
}

.mbr-bk__price {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
}

.mbr-bk__price-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 13px;
  font-weight: 500;
  color: var(--mbr-color-ink-secondary);
}

.mbr-bk__price-line--total {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.mbr-bk__price-line--total strong {
  font-family: var(--mbr-font-headline) !important;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.02em;
  text-transform: none;
  color: var(--mbr-color-ink-strong);
}
.mbr-bk__ctabar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
  background: rgba(var(--mbr-color-canvas-rgb), 0.95);
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.8);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
}

.mbr-bk__ctabar-inner {
  max-width: 440px;
  margin: 0 auto;
  padding: 12px 20px calc(24px + env(safe-area-inset-bottom));
}

.mbr-bk__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 56px;
  border: 0;
  border-radius: var(--mbr-radius-full);
  background: var(--mbr-color-primary);
  box-shadow: 0 8px 20px -4px rgba(var(--mbr-color-primary-rgb), 0.35);
  font-family: var(--mbr-font-headline) !important;
  font-size: 14px;
  font-weight: 700;
  color: var(--mbr-color-on-primary);
  transition: transform 0.15s ease;
}

.mbr-bk__cta:active {
  transform: scale(0.98);
}

.mbr-bk__cta svg {
  width: 16px;
  height: 16px;
}

.mbr-bk__back:focus-visible,
.mbr-bk__cta:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}
</style>
